import { createSelectionContext } from "../../selection/SelectionProvider";
import { ResourceView } from "../../../dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const {
  SelectionProvider: LSResultsSelectionProvider,
  useSelection: useLSResultsSelection,
} = createSelectionContext<ResourceView | ResourceDWR>();
